import runningIcon  from "../../assets/icons/running.png";
import cyclingIcon  from "../../assets/icons/cycling.png";
import swimIcon     from "../../assets/icons/swim.png";
import dayoffIcon   from "../../assets/icons/dayoff.png";
import strengthIcon from "../../assets/icons/strength.png";
import walkIcon     from "../../assets/icons/walk.png";
import otherIcon    from "../../assets/icons/other.png";
import challengeIcon from "../../assets/icons/challenge.png";

// ⚠️ type sigue en español para compatibilidad con la DB y el backend
export const activityOptions = [
  { type: "Correr",   key: "running",  icon: runningIcon,  color: "#9C27B0" },
  { type: "Ciclismo", key: "cycling",  icon: cyclingIcon,  color: "#4CAF50" },
  { type: "Nadar",    key: "swimming", icon: swimIcon,     color: "#03A9F4" },
  { type: "Descanso", key: "rest",     icon: dayoffIcon,   color: "#00BCD4" },
  { type: "Fuerza",   key: "strength", icon: strengthIcon, color: "#6A1B9A" },
  { type: "Caminar",  key: "walking",  icon: walkIcon,     color: "#FF9800" },
  { type: "Otro",     key: "other",    icon: otherIcon,    color: "#37474F" },
  { type: "Competencia", key: "competition", icon: challengeIcon, color: "#E91E63" },
];

export const typeMapping = {
  correr:            "Correr",
  ciclismo:          "Ciclismo",
  nadar:             "Nadar",
  "día de descanso": "Descanso",
  "descanso":        "Descanso",
  fuerza:            "Fuerza",
  caminar:           "Caminar",
  otro:              "Otro",
  competencia:       "Competencia",
};

export const getActivityIcon = (type) => {
  if (!type) return otherIcon;
  const formattedType = String(type).trim().toLowerCase();
  const activity = activityOptions.find((a) => a.type.toLowerCase() === formattedType);
  return activity ? activity.icon : otherIcon;
};

/**
 * Devuelve el label traducido a partir del tipo (en español) o de la key.
 * Requiere pasar la función t() de useTranslation.
 *
 * Uso: getActivityLabel('Correr', t)  → 'Running' (en inglés)
 *      getActivityLabel('running', t) → 'Running'
 */
export const getActivityLabel = (typeOrKey, t) => {
  if (!t || !typeOrKey) return String(typeOrKey || '');

  const s = String(typeOrKey).trim().toLowerCase();

  // Buscar por key directamente
  const byKey = activityOptions.find((a) => a.key === s);
  if (byKey) return t(`activityLabels.${byKey.key}`);

  // Buscar por type (en español)
  const byType = activityOptions.find((a) => a.type.toLowerCase() === s);
  if (byType) return t(`activityLabels.${byType.key}`);

  // Fallback por normalización
  if (s.startsWith('cor') || s.includes('run'))      return t('activityLabels.running');
  if (s.startsWith('cicl') || s.includes('bike'))    return t('activityLabels.cycling');
  if (s.startsWith('nad') || s.includes('swim'))     return t('activityLabels.swimming');
  if (s.startsWith('fuer') || s.includes('strength'))return t('activityLabels.strength');
  if (s.startsWith('cam') || s.includes('walk'))     return t('activityLabels.walking');
  if (s.includes('desc') || s.includes('rest'))      return t('activityLabels.rest');
  if (s.includes('compet'))                             return t('activityLabels.competition');

  return String(typeOrKey);
};
